export default {
  enteringsubsidies: {
    title: "Ввод субсидий/соц. доплат"
  }
};
